module.exports = __webpack_public_path__ + "img/1623.9a667241.png";